import { c as _c } from "react/compiler-runtime";
// «Стань продавцом» — статичная страница по кадру Figma 4032:111195, вход —
// ссылка «Продавать на OSMIX» в подвале. Первый экран: градиент с ноутбуком и
// телефоном (картинки собраны из отрисовки кадра: фон — сам градиент без текста,
// устройства — вырезкой), заголовок 32/42 w700, подзаголовок 20/25 w500 и белая
// кнопка 56 r12 «Стать продавцом на OSMIX». Ниже — карточка «Добро пожаловать»
// (r30, тень), заголовок 25/34 w600 и восемь преимуществ: плитки #FAFAFA r30
// pad 15, значок 54 в оранжевом градиенте, 20/23 w600 + 16/22. В конце — кнопка
// «Узнать ещё об OSMIX» #FA5C2E.
import { useTranslation } from "react-i18next";
import { ArrowRightBoldIcon, SettingBoldIcon, ThreeUsersBoldIcon, TwoUsersBoldIcon, WalletBoldIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import logo from "@/logo.svg";
import { METRIKA_GOALS, reachGoal } from "@/lib/metrika-ecommerce";
import heroBg from "./become-seller/hero-bg.jpg";
import heroDevices from "./become-seller/hero-devices.webp";

/*
 * Кабинет продавца живёт на соседнем поддомене (infra/deploy/stack.config.ts:
 * app.<домен> — витрина, seller.<домен> — кабинет). Явный адрес можно задать
 * сборке `BUN_PUBLIC_SELLER_WEB_URL`; иначе берём поддомен рядом с витриной,
 * а на локальном стенде — dev-адрес из compose.
 */
function sellerWebUrl(): string {
  // Bun подставляет BUN_PUBLIC_* при сборке; без переменной `process` в браузере нет.
  const fromEnv = typeof process !== "undefined" ? process.env.BUN_PUBLIC_SELLER_WEB_URL : undefined;
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (typeof window !== "undefined") {
    const {
      protocol,
      hostname,
      port
    } = window.location;
    if (hostname.startsWith("app.")) return `${protocol}//seller.${hostname.slice(4)}${port ? `:${port}` : ""}`;
  }
  return "http://seller.osmix.localhost";
}
const FEATURES: {
  key: string;
  icon: React.ReactNode;
}[] = [{
  key: "prices",
  icon: <WalletBoldIcon size={24} />
}, {
  key: "shipping",
  icon: <ArrowRightBoldIcon size={24} />
}, {
  key: "manager",
  icon: <TwoUsersBoldIcon size={24} />
}, {
  key: "fair",
  icon: <TwoUsersBoldIcon size={24} />
}, {
  key: "audience",
  icon: <ThreeUsersBoldIcon size={24} />
}, {
  key: "noFines",
  icon: <ThreeUsersBoldIcon size={24} />
}, {
  key: "growth",
  icon: <ThreeUsersBoldIcon size={24} />
}, {
  key: "custom",
  icon: <SettingBoldIcon size={24} />
}];
export function BecomeSellerPage() {
  const $ = _c(57);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = sellerWebUrl();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seller = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundImage: `url("${heroBg}")`,
      backgroundColor: "#EF4A1E"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("sell.title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h1 className="text-[26px] leading-[34px] font-bold min-[744px]:text-[32px] min-[744px]:leading-[42px]">{t2}</h1>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("sell.subtitle");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <p className="max-w-[453px] text-[16px] leading-[21px] font-medium min-[744px]:text-[20px] min-[744px]:leading-[25px]">{t4}</p>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-col gap-3 text-white">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("sell.cta");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <Button asChild={true} size="xl" className="w-fit bg-white px-6 text-[18px] leading-[23px] text-[#E85502] hover:bg-white/90"><a href={`${seller}/register`} onClick={_temp}>{t7}</a></Button>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="flex w-full max-w-[477px] flex-col gap-10 self-start lg:shrink-0 lg:self-center lg:pb-[67px]">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("sell.devicesAlt");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <img src={heroDevices} alt={t10} width={672} height={482} className="w-full max-w-[672px] lg:-mr-[22px] lg:-mt-[15px] lg:-mb-[18px] lg:ml-auto" />;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <section data-header-hero={true} className="relative -mx-4 -mt-2.5 overflow-hidden bg-cover bg-center px-4 pt-[100px] pb-16 md:-mx-8 md:px-8 lg:min-h-[675px] lg:px-[30px] lg:pt-[137px] lg:pb-[95px]" style={t1}><div className="mx-auto flex max-w-[1140px] flex-col items-center gap-8 lg:flex-row lg:items-center lg:gap-[25px]">{t9}{t11}</div></section>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <img src={logo} alt="OSMIX" className="h-6 w-auto shrink-0 min-[744px]:h-auto min-[744px]:w-[146px]" />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("sell.welcome");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = <div className="relative z-[1] mx-auto -mt-10 flex w-full max-w-[946px] flex-col items-start gap-4 rounded-[30px] bg-white p-6 shadow-[0_4px_6px_-2px_rgba(38,59,103,0.03),0_12px_16px_-4px_rgba(38,58,98,0.08)] min-[744px]:flex-row min-[744px]:gap-[30px] min-[744px]:p-[30px]">{t13}<p className="text-[16px] leading-[22px] text-ds-ink">{t14}</p></div>;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("sell.featuresTitle");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = <h2 className="max-w-[574px] text-center text-[22px] leading-[30px] font-semibold text-ds-ink min-[744px]:text-[25px] min-[744px]:leading-[34px]">{t16}</h2>;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = FEATURES.map(f => <li key={f.key} className="flex flex-col items-center gap-5 rounded-[30px] bg-[#FAFAFA] p-[15px] text-center"><span className="grid size-[54px] shrink-0 place-items-center rounded-full bg-[linear-gradient(135deg,#F78522_0%,#FF6D38_50%,#FF4500_100%)] text-white">{f.icon}</span><span className="flex flex-col gap-2 pb-[15px]"><span className="text-[20px] leading-[23px] font-semibold tracking-[-0.31px] text-ds-ink">{t(`sell.features.${f.key}.title`)}</span><span className="text-[16px] leading-[22px] text-ds-ink">{t(`sell.features.${f.key}.text`)}</span></span></li>);
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t18) {
    t19 = <ul className="grid w-full grid-cols-1 gap-2.5 min-[480px]:grid-cols-2 lg:grid-cols-4">{t18}</ul>;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t("sell.ownClients");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t20) {
    t21 = <p className="max-w-[760px] text-center text-[16px] leading-[22px] text-ds-ink" data-testid="sell-own-clients">{t20}</p>;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t) {
    t22 = t("sell.more");
    $[44] = t;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t22) {
    t23 = <Button asChild={true} variant="accent" size="xl" className="px-6 text-[18px] leading-[23px]"><a href={seller}>{t22}</a></Button>;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t17 || $[49] !== t19 || $[50] !== t21 || $[51] !== t23) {
    t24 = <section className="mx-auto flex w-full max-w-[1097px] flex-col items-center gap-[30px] pt-10">{t17}{t19}{t21}{t23}</section>;
    $[48] = t17;
    $[49] = t19;
    $[50] = t21;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t12 || $[54] !== t15 || $[55] !== t24) {
    t25 = <div className="flex flex-col">{t12}{t15}{t24}</div>;
    $[53] = t12;
    $[54] = t15;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  return t25;
}
function _temp() {
  return reachGoal(METRIKA_GOALS.becomeSeller);
}